import AdvertismentReducer from "./reducer";

export const setCampaignList = (payload) => (dispatch) => {
  dispatch(AdvertismentReducer.actions.setCampaignList(payload));
};

export const setCampaign = (payload) => (dispatch) => {
  dispatch(AdvertismentReducer.actions.setCampaign(payload));
};

export const addList = (payload) => (dispatch) => {
  dispatch(AdvertismentReducer.actions.addList(payload));
};

export const setAdvCategoryList = (payload) => (dispatch) => {
  dispatch(AdvertismentReducer.actions.setAdvCategoryList(payload));
};

export const addAdvCategoryList = (payload) => (dispatch) => {
  dispatch(AdvertismentReducer.actions.addAdvCategoryList(payload));
};

export const setAdvCategory = (payload) => (dispatch) => {
  dispatch(AdvertismentReducer.actions.setAdvCategory(payload));
};

export const clearedSelectItems = () => (dispatch) => {
  dispatch(AdvertismentReducer.actions.clearedSelectItems());
};
